// extracted by mini-css-extract-plugin
module.exports = {"desc":"footer_desc__AvmME"};